









































































































































































































































import {Component, Vue} from 'vue-property-decorator';

@Component({
  components: {},
})
export default class PlansBenefitsList extends Vue {

  showFullList: boolean = false;


}
